export default class Tracking {
  /**
   * @param {string} eventName
   * @param {object} properties
   */
  constructor(eventName, properties) {
    // we could make the url dynamic but for now it suits our need to be directly in the constructor
    this.url = '/api/tracking';
    this.eventName = eventName;
    this.properties = properties;
  }

  /**
   * @param {function} callback
   */
  track(callback = null) {
    const payload = {
      event_name: this.eventName,
      properties: this.properties,
    };

    fetch(this.url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content,
      },
      body: JSON.stringify(payload),
    }).then(r => {
      if (callback !== null) callback(r);
    });
  }
}
